export enum GitCommands {
  add = 'add',
  push = 'push',
  deployPHP = 'deployPHP',
  commitKit = 'commitKit',
  commit = 'commit',
}
